import { render, staticRenderFns } from "./LicensePlate.vue?vue&type=template&id=686bed98&scoped=true&"
import script from "./LicensePlate.vue?vue&type=script&lang=js&"
export * from "./LicensePlate.vue?vue&type=script&lang=js&"
import style0 from "./LicensePlate.vue?vue&type=style&index=0&id=686bed98&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686bed98",
  null
  
)

export default component.exports